import { COUNTRY_BY_CODE, fmtSalaryBand, salaryFromInput } from "@/lib/countries";

const count = (s) => (s || "").split(",").map((x) => x.trim()).filter(Boolean).length;

export const skillSummary = (f) => `${count(f.must_haves)} must-haves · ${count(f.nice_to_haves)} nice-to-haves`;

export const locationSummary = (f) => {
  const where = f.remote ? "Remote" : [f.city, COUNTRY_BY_CODE[f.country_code]?.name].filter(Boolean).join(", ");
  const pay = f.salary_min || f.salary_max
    ? fmtSalaryBand(salaryFromInput(f.salary_min, f.salary_unit), salaryFromInput(f.salary_max, f.salary_unit), f.salary_currency, f.salary_unit || "annual")
    : "";
  return [where, pay].filter(Boolean).join(" · ");
};

export const stageSummary = (f) =>
  [f.stages?.telephonic && "Phone", f.stages?.video && "Video", f.stages?.coding && "Coding"].filter(Boolean).join(" · ") || "No stages selected";

export const codingSummary = (f) =>
  `${f.coding_difficulty || "medium"} · ${f.coding_time_limit_min || 45} min · ${(f.coding_problems || []).length} problems`;

// Which job-form sections have their required fields filled (drives the green ticks).
export const sectionDone = (f) => ({
  basics: !!(f.title?.trim() && f.description?.trim() && f.job_type && f.client_id),
  skills: count(f.must_haves) > 0,
  location: !!(f.country_code && (f.remote || f.city?.trim()) && (!(f.salary_min || f.salary_max) || f.salary_currency !== "INR" || f.salary_unit)),
  stages: !!(f.stages?.telephonic || f.stages?.video || f.stages?.coding),
  coding: !!(f.coding_topics?.trim() && f.coding_languages?.length),
});

// First still-missing required field per section (testid), for "jump to missing field".
export const missingField = (f, p) => {
  const d = sectionDone(f);
  const pick = (...pairs) => (pairs.find(([miss]) => miss) || [])[1];
  return {
    basics: d.basics ? null : pick([!f.title?.trim(), `${p}-title`], [!f.client_id, `${p}-client-id`], [!f.job_type, `${p}-job-type-fte`], [!f.description?.trim(), `${p}-description`]),
    skills: d.skills ? null : `${p}-must-input`,
    location: d.location ? null : pick([!f.remote && !f.city?.trim(), `${p}-city`], [true, `${p}-salary-unit`]),
    stages: d.stages ? null : `${p}-stage-telephonic`,
    coding: d.coding ? null : `${p}-coding-topics`,
  };
};
